import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
// import { Navbar, NavItem, Nav, NavDropdown} from "react-bootstrap";
import logo from './logo.svg';
import './css/App.css';
import Routes from "./routes";
// import { LinkContainer } from "react-router-bootstrap";
import classNames from 'classnames';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
// import { css } from 'react-emotion';
// import { CircleLoader } from 'react-spinners';
import HomeIcon from '@material-ui/icons/Home';
// import BellIcon from 'react-bell-icon';
import moment from 'moment';
import { format_date_only_new, formatNumber, toInt, HtmlTooltip } from './Utils';
import Config from './Config';
import { ROLES } from './Roles';
import { UserService } from './Services/UserService';
import WifiOffIcon from '@material-ui/icons/WifiOff';
import Snackbar from '@material-ui/core/Snackbar';
import MySnackbarContent from './components/SnackBar';
import DialogMUI from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles, CssBaseline, AppBar, Toolbar, IconButton, Drawer, Typography, Divider, ListItem, ListItemIcon, ListItemText, Container, Collapse, List, Icon, Fade, LinearProgress, Badge, Slide, useScrollTrigger, Tooltip, FormControl, OutlinedInput, ThemeProvider, createMuiTheme } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { ReportService } from './Services/ReportService';
import ProgressDialog from './components/ProgressDialog';
import { messaging, requestToken, unregister, messaginIsSupported } from './Notification/init-fcm';
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DashboardContextProvider } from './DashboardContext';
import { orange } from '@material-ui/core/colors';

const theme = createMuiTheme({
  status: {
    danger: orange[500],
  },
});

function HideOnScroll(props) {
  const { children } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger();

  return (
    <Slide appear={false} direction="down" in={window.innerWidth < 1000 ? !trigger : true}>
      {children}
    </Slide>
  );
}

const drawerWidth = 300;
const styles = theme => ({
  root: {
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      marginBottom: 60
    }
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    background: '#008c41'
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 12,
    // marginRight: 36,
  },
  hide: {
    display: 'none',
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 8px',
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  sectionMobile: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  },
  sectionDesktop: {
    display: 'flex',
    fontSize: 16,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  accountCircle: {
    marginRight: theme.spacing(3)
  },
  menuIcon: {
    minWidth: 32
  },
  subMenuTitle: {
    // paddingLeft: 32, 
    paddingTop: 0,
    paddingBottom: 0
  },
  subMenuItem: {
    color: 'black',
    // paddingTop: 0, 
    // paddingBottom: 0
  },
  nested: {
    paddingLeft: 48,
    color: 'black',
    paddingTop: 0,
    paddingBottom: 0,
  },
  link: {
    textDecoration: 'none !important',
    color: 'black'
  },
  deliveryBadge: {
    position: "absolute",
    right: 300,
    [theme.breakpoints.down('md')]: {
      right: 120,
    }
  },
  title: {
    [theme.breakpoints.down('md')]: {
      flexGrow: 1,
      alignSelf: 'flex-end',
      marginTop: 8,
      textAlign: 'left'
    }
  },
  toolbarAppBar: {
    [theme.breakpoints.down('md')]: {
      minHeight: 100,
      alignItems: 'flex-start',
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    }
  },
  networkBadge: {
    position: "absolute",
    right: 300,
    [theme.breakpoints.down('md')]: {
      right: 120,
    }
  },
});

global.user = {};

class App extends Component {

  intervalID = undefined;

  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      user: null,
      loading: false,
      latitude: null,
      longitude: null,
      alertMessages: [],
      show: false,
      isAlertVisible: false,
      modules_enabled: {
        customer_app_options: false,
        inventory_management: true,
        b2c_module: false,
        b2b_module: true,
        promotions_module: false
      },
      sb: {
        open: false,
        autohide: 6000,
      },
      openDialog: false,
      openDialog3Option: false,
      title: "",
      open: false,
      openDrawer: {
        store: false,
        customer: false,
        reports: false,
        inventory: false,
        tools: false
      },
      sales: undefined,
      returns: undefined,
      last_synced: moment(),
      startdate: moment().startOf('day'),
      enddate: moment().startOf('day'),
      badgeText: '0/0',
      progressOpen: false,
      progressMessage: null,
      isDisconnected: false
    };

    this.updateUser = this.updateUser.bind(this);
    this.isLoading = this.isLoading.bind(this);
    this.updateLocation = this.updateLocation.bind(this);
    this.addAlertMessage = this.addAlertMessage.bind(this);
    this.alertPopover = this.alertPopover.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentWillMount() {
    this.handleConnectionChange();
    window.addEventListener('online', this.handleConnectionChange);
    window.addEventListener('offline', this.handleConnectionChange);
    let user = JSON.parse(localStorage.getItem('user'));
    this.setState({ user: user });
    if (user == null) {
      this.props.history.push("/login");
    };
  }

  handleConnectionChange = () => {
    const condition = navigator.onLine ? "online" : "offline";
    if (condition === "online") {
      const webPing = setInterval(() => {
        fetch("mooservice.happymilk.co", {
          mode: "no-cors",
        })
          .then(() => {
            this.setState({
              isDisconnected: false,
            });
            clearInterval(webPing);
          })
          .catch(() => {
            this.setState({
              isDisconnected: true,
            });
          });
      }, 2000);
      return;
    }
    this.setState({
      isDisconnected: true,
    });
  };

  handleClick = (type) => {
    let openDrawer = this.state.openDrawer;
    openDrawer[type] = !openDrawer[type];
    this.setState({ openDrawer });
  }

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = (e) => {
    this.setState({ open: false });
  };

  closeConfirmDialog = () => {
    this.setState({ openDialog: false, showfield: false, fieldHint: '', fieldValue: '', dialog_field_text: undefined });
  }

  closeConfirmDialog3Option = () => {
    this.setState({ openDialog3Option: false, dialog3OptionData: {} });
  }

  handleSBClose = () => {
    this.setState(prevState => ({
      sb: {
        ...prevState.sb,
        open: false,
        message: '',
        varient: 'info',
        actionText: undefined,
        actionCallback: undefined,
      }
    }));
  }

  showSnackBar = (message, variant, actionText, actionCallback) => {
    this.setState(prevState => ({
      sb: {
        ...prevState.sb,
        open: true,
        message: message,
        varient: variant,
        actionText,
        actionCallback,
      }
    }));
  }

  showConfirmDialog = (dialog_message, dialog_title, confirmAction, cancel_title = "Cancel", accept_title = "Confirm", showfield = false, fieldHint = '', fieldValue = '') => {
    this.setState({
      dialog_message: dialog_message,
      dialog_title: dialog_title,
      openDialog: true,
      confirmAction: confirmAction,
      cancel_title: cancel_title,
      accept_title: accept_title,
      showfield: showfield,
      fieldHint: fieldHint,
      fieldValue: fieldValue,
      dialog_field_text: fieldValue
    });
  }

  showConfirmDialog3Option = (dialog_message, dialog_title, rightButtonText, rightButtonAction, middleButtonText, middleButtonAction) => {
    this.setState({
      openDialog3Option: true,
      dialog3OptionData: {
        dialog_message: dialog_message,
        dialog_title: dialog_title,
        rightButtonText: rightButtonText,
        rightButtonAction: rightButtonAction,
        middleButtonText: middleButtonText,
        middleButtonAction: middleButtonAction
      }
    });
  }

  alertPopover() {
    if (this.state.isAlertVisible) {
      this.handleShow();
    }
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentWillUnmount() {
    if (this.intervalID) {
      window.removeEventListener("focus", this.getData);
      clearInterval(this.intervalID);
      window.removeEventListener('online', this.handleConnectionChange);
      window.removeEventListener('offline', this.handleConnectionChange);
    }
  }

  async componentDidMount() {
    try {
      // if(this.state.user !== null) {
      //   this.userHasAuthenticated(true);
      // }
      if (this.state.user) {
        let body = {
          mobile_no: this.state.user.mobile_no,
          code: this.state.user.code
        };
        UserService.authenticate(body)
          .then((data) => {
            if (data.id && data.status === '1') {
              this.updateUser(data);
              localStorage.setItem('user', JSON.stringify(data));
              this.userHasAuthenticated(true);

              var dateToCheck = moment().set({ hour: Config.defaultAlerts.import.hr, minute: Config.defaultAlerts.import.min, second: 0, millisecond: 0 });
              if (moment().isAfter(dateToCheck)) {
                this.setState({ alertMessages: [...this.state.alertMessages, <div key="import" style={{ cursor: "pointer" }} onClick={() => { this.handleClose(); this.props.history.push("/import") }}>Dont <strong>Forget</strong> to import schedules for - {moment().format(format_date_only_new)}</div>] });
              }

              // setTimeout(() =>{
              //   this.setState({isAlertVisible: this.state.alertMessages.length > 0})
              // }, 2000);
              // setInterval(() =>{
              //   this.setState({isAlertVisible: this.state.alertMessages.length > 0})
              // }, 60000);

              if (messaginIsSupported) {
                messaging.requestPermission()
                  .then(() => {
                    console.log("Have Permission");
                    requestToken(this.state.user);
                  })
                  .catch((err) => {
                    console.log("Unable to get permission to notify.", err);
                  });
              }

              if (messaginIsSupported) {
                messaging.onMessage((payload) => {
                  if (!payload.data.schedule_change) {
                    // let title = payload.data.title || '';
                    let body = payload.data.body || '';
                    // this.showSnackBar(title, 'info');
                    body = body.split('\n').map((item, key) => {
                      return <span key={key}>{item}<br /></span>
                    });
                    this.showConfirmDialog(body, 'Notification');
                    console.log('Message received. ', payload);
                  }
                });
              }


              this.getData();
              this.intervalID = setInterval(this.getData.bind(this), Config.REFRESH_INTERVAL);
              window.addEventListener("focus", this.getData);

              if (data['app-version'] && data['app-version'] !== global.appVersion) {
                this.showSnackBar('New App Update Available. Please click Reload or CTRL+SHIFT+R', 'info', 'RELOAD', () => {
                  window.location.reload(true)
                })
              }

              this.props.history.push(this.props.location.pathname);
            } else {
              this.props.history.push("/login");
            }
            this.setAuthenticating(false);
          })
          .catch((error) => {
            this.props.history.push("/login");
            this.setAuthenticating(false);
          });
      }
    } catch (e) {
      if (e !== 'No current user') {
        alert(e);
      }
      this.setAuthenticating(false);
    }

    if (navigator.geolocation) {
      this.updateLocation();
    } else {
      // no can do
    }
  }

  getData = () => {
    this.setState({
      startdate: moment().startOf('day'),
      enddate: moment().endOf('day')
    },
      () => {
        this.fetchTurnoverSummary();
      });
  }

  fetchTurnoverSummary = () => {
    ReportService.turnoverSummary(1, this.state.startdate, this.state.enddate)
      .then((data) => {
        let total_amount = 0;
        if (data.summary.length > 0) {
          total_amount = data.summary[0].total_amount;
        }
        this.setState({ sales: total_amount, last_synced: moment() });
      });

    if (this.state.modules_enabled.b2b_module) {
      ReportService.returnsValueSummary(1, this.state.startdate, this.state.enddate)
        .then((data) => {
          // console.log(data);
          let total_amount = 0;
          if (data.summary.length > 0) {
            total_amount = data.summary[0].total_amount;
          }
          this.setState({ returns: total_amount });
        });
    }

    let badgeText = this.state.badgeText;
    ReportService.routeSummary(this.state.startdate)
      .then((data) => {
        // console.log(data);
        if (data.summary.pending.length > 0 || data.summary.completed.length > 0) {
          let completed = 0, pending = 0;

          pending = data.summary.pending.map(s => s.count).reduce(function (accumulator, currentValue) {
            return accumulator + toInt(currentValue);
          }, pending);

          completed = data.summary.completed.map(s => s.count).reduce(function (accumulator, currentValue) {
            return accumulator + toInt(currentValue);
          }, completed);
          badgeText = `${completed}/${completed + pending}`;
        }
        this.setState({ badgeText });
      })
  }

  updateLocation(position) {
    navigator.geolocation.getCurrentPosition((position) => {
      this.setState({ latitude: position.coords.latitude, longitude: position.coords.longitude });
    });
  }

  addAlertMessage(alertMessages) {
    this.setState(prevState => ({
      alertMessages: [...prevState.alertMessages, alertMessages]
    }));
  }

  isLoading(loading) {
    this.setState({ loading: loading });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  handleLogout = event => {
    this.userHasAuthenticated(false);
    let user = JSON.parse(localStorage.getItem('user'));
    if (messaginIsSupported) {
      unregister(user);
    }
    localStorage.removeItem('user');
    this.props.history.push("/login");
  }

  updateUser(user) {
    global.user = user;
    this.setState({ user: user });
  }

  setTitle = (message) => {
    this.setState({
      title: message
    });
  }

  showProgressDialog = (message = null) => {
    this.setState({
      progressOpen: true,
      progressMessage: message
    });
  }

  updateProgressMessage = (message = null) => {
    this.setState({
      progressMessage: message
    });
  }

  closeProgressDialog = () => {
    this.setState({
      progressOpen: false,
      progressMessage: null
    });
  }

  setAuthenticating = (isAuthenticating) => {
    this.setState({ isAuthenticating: isAuthenticating });
  };

  render() {
    let classes = this.props.classes;
    let dialog3OptionData = this.state.dialog3OptionData;

    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      user: this.state.user,
      updateUser: this.updateUser,
      isLoading: this.isLoading,
      loading: this.state.loading,
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      updateLocation: this.updateLocation,
      addAlertMessage: this.addAlertMessage,
      modules_enabled: this.state.modules_enabled,
      showStore: this.state.showStore,
      showPromotions: this.state.showPromotions,
      showSnackBar: this.showSnackBar,
      showConfirmDialog: this.showConfirmDialog,
      showConfirmDialog3Option: this.showConfirmDialog3Option,
      closeConfirmDialog: this.closeConfirmDialog,
      closeConfirmDialog3Option: this.closeConfirmDialog3Option,
      setTitle: this.setTitle,
      refreshStats: this.getData,
      showProgressDialog: this.showProgressDialog,
      updateProgressMessage: this.updateProgressMessage,
      closeProgressDialog: this.closeProgressDialog,
      setAuthenticating: this.setAuthenticating,
    };

    return (
      <div className="App container">
        <ThemeProvider theme={theme}>
          <DndProvider backend={HTML5Backend}>
            <DashboardContextProvider>
              <div className={classes.root}>
                <Fade
                  in={this.state.loading}
                  style={{
                    transitionDelay: this.state.loading ? '50ms' : '0ms',
                  }}
                  unmountOnExit
                >
                  <LinearProgress id="test" style={{ height: 5, position: "fixed", top: 64, width: "95%" }} color="secondary" />
                </Fade>
                <CssBaseline />
                <HideOnScroll {...this.props}>
                  <AppBar position="fixed"
                    className={classNames(classes.appBar, {
                      [classes.appBarShift]: this.state.open,
                    })}
                  >
                    <Toolbar disableGutters={!this.state.open} className={classes.toolbarAppBar}>
                      {this.state.isAuthenticated &&
                        <IconButton
                          color="inherit"
                          aria-label="Open drawer"
                          onClick={this.handleDrawerOpen}
                          className={classNames(classes.menuButton, {
                            [classes.hide]: this.state.open,
                          })}
                        >
                          <MenuIcon />
                        </IconButton>
                      }
                      {this.state.isAuthenticated && !this.state.open &&
                        <Typography variant="h6" color="inherit" className={classes.title} noWrap>
                          {this.state.title}
                        </Typography>
                      }
                      {
                        this.state.modules_enabled.b2b_module && !this.state.isDisconnected && this.state.isAuthenticated && this.state.sales > -1 &&
                        <Button color="inherit" className={classes.sectionMobile} style={{ position: "absolute", right: 600 }}>{`Sales: ${formatNumber(this.state.sales)}`}</Button>
                      }
                      {
                        this.state.modules_enabled.b2b_module && !this.state.isDisconnected && this.state.isAuthenticated && this.state.returns > -1 &&
                        <Button color="inherit" className={classes.sectionMobile} style={{ position: "absolute", right: 400 }}>{`Returns: ${formatNumber(this.state.returns)}`}</Button>
                      }
                      {!this.state.isDisconnected && this.state.isAuthenticated &&
                        <Badge className={classes.deliveryBadge} badgeContent={this.state.badgeText} color="secondary" children={
                          <Link to="/storedeliverystatus" ><Icon fontSize="large" style={{ textDecoration: 'none !important', color: 'white' }}>local_shipping</Icon></Link>
                        } />
                      }
                      {this.state.isDisconnected &&
                        <HtmlTooltip title={'Unable to reach the server. App offline.'}>
                          <IconButton className={classes.networkBadge} color="inherit"><WifiOffIcon /></IconButton>
                        </HtmlTooltip>
                      }
                      {this.state.isAuthenticated &&
                        <Button color="inherit" className={classes.sectionMobile} style={{ position: "absolute", right: 130 }}>{this.state.user.name ? this.state.user.name : ''}</Button>
                      }
                      {!this.state.isAuthenticating && (this.state.isAuthenticated ?
                        <Tooltip title="Logout">
                          <IconButton color="inherit" style={{ position: "absolute", right: 20 }} onClick={this.handleLogout}><ExitToAppOutlinedIcon /></IconButton>
                        </Tooltip>
                        :
                        //<Button color="inherit" style={{position: "absolute", right: 20, color: "white"}}><Link to="/login" style={{color: "inherit", textDecoration: "none"}}>Login</Link></Button>
                        ''
                      )}
                    </Toolbar>
                  </AppBar>
                </HideOnScroll>
                {this.state.isAuthenticated &&
                  <Drawer
                    anchor="left"
                    className={classNames(classes.drawer, {
                      [classes.drawerOpen]: this.state.open,
                      [classes.drawerClose]: !this.state.open,
                    })}
                    classes={{
                      paper: classNames({
                        [classes.drawerOpen]: this.state.open,
                        [classes.drawerClose]: !this.state.open,
                      }),
                    }}
                    open={this.state.open}
                    onClose={this.handleDrawerClose}
                  >
                    <div className={classes.toolbar}>
                      <div style={{ float: 'left', width: "100%", marginLeft: 24 }}>
                        <Link to="/" onClick={this.handleDrawerClose}><img src={logo} width="60px" alt="Happy Milk" /></Link>
                      </div>
                      <IconButton onClick={this.handleDrawerClose}>
                        {/* <AccountCircleIcon className={classes.accountCircle}/> */}
                        {this.state.isAuthenticated &&
                          <section className={classes.sectionDesktop}>{this.state.user.name}</section>
                        }
                        <ChevronLeftIcon />
                      </IconButton>
                    </div>
                    <div style={{ height: '82%', overflowY: 'auto' }}>
                      <Divider />
                      {
                        <Link to="/" style={{ textDecoration: 'none', color: 'black' }} onClick={this.handleDrawerClose}>
                          <ListItem button key="Home">
                            <ListItemIcon className={classes.menuIcon}><HomeIcon /></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Home</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      <Divider />
                      {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                        <Link to="/product" style={{ textDecoration: 'none', color: 'black' }} onClick={this.handleDrawerClose}>
                          <ListItem button key="Product">
                            <ListItemIcon className={classes.menuIcon}><Icon>storefront</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Product</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      <Divider />
                      {this.state.modules_enabled.b2c_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                        <List className={classes.subMenuTitle}>
                          <ListItem button onClick={(e) => this.handleClick('customer')}>
                            <ListItemIcon className={classes.menuIcon}><Icon>people</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2" align="left" className="sub-menu">Customer</Typography>} />
                            {this.state.openDrawer['customer'] ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>
                          <Collapse in={this.state.openDrawer['customer']} timeout="auto" unmountOnExit className={classes.subMenuItem}>
                            <List component="div" disablePadding onClick={this.handleDrawerClose}>
                              {
                                this.state.modules_enabled.b2c_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                                <Link to="/customer" className={classes.link} onClick={this.handleDrawerClose}>
                                  <ListItem button key="Manage Customer" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Manage Customers</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                this.state.modules_enabled.b2c_module &&
                                <Link to="/customer/schedule" className={classes.link} onClick={this.handleDrawerClose}>
                                  <ListItem button key="Customer Transactions" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Customer Transactions</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              <Link to="/customer/delivery/schedule" className={classes.link}>
                                <ListItem button key="Customer Delivery Schedule" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Customer Delivery Schedule</Typography>} />
                                </ListItem>
                              </Link>
                            </List>
                          </Collapse>
                        </List>
                      }
                      <Divider />
                      {/* {this.state.modules_enabled.b2c_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                        <Link to="/customer" style={{ textDecoration: 'none', color: 'black' }} onClick={this.handleDrawerClose}>
                          <ListItem button key="Customer">
                            <ListItemText primary={<Typography variant="subtitle2">Customer</Typography>} />
                          </ListItem>
                        </Link>
                      } */}
                      {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.DELIVERY_MANAGEMENT) || this.state.user.roles.includes(ROLES.INVENTORY_MANAGEMENT) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                        <List className={classes.subMenuTitle}>
                          <ListItem button onClick={(e) => this.handleClick('store')}>
                            <ListItemIcon className={classes.menuIcon}><Icon>store</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2" align="left" className="sub-menu">Store</Typography>} />
                            {this.state.openDrawer['store'] ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>
                          <Collapse in={this.state.openDrawer['store']} timeout="auto" unmountOnExit className={classes.subMenuItem}>
                            <List component="div" disablePadding onClick={this.handleDrawerClose}>
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                                <Link to="/store" className={classes.link}>
                                  <ListItem button key="Store List" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store List</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/storeroutemapping" className={classes.link}>
                                  <ListItem button key="Store Route Mapping" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Route Mapping</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              <Link to="/storedeliverystatus" className={classes.link}>
                                <ListItem button key="Daily Delivery status" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Daily Delivery status</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/viewstoredelivery" className={classes.link}>
                                <ListItem button key="View Store Deliveries" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Store Deliveries</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/storedeliveryschedule" className={classes.link}>
                                <ListItem button key="Store Delivery Schedule" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Delivery Schedule</Typography>} />
                                </ListItem>
                              </Link>
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/store/delivery/sequence/planner" className={classes.link}>
                                  <ListItem button key="Delivery Sequence Planner" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Delivery Sequence Planner</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              <Link to="/storesummary" className={classes.link}>
                                <ListItem button key="Store Summary" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Summary</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/transactions" className={classes.link}>
                                <ListItem button key="Payment Transactions" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Payment Transactions</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/storedeliverypendingapproval" className={classes.link}>
                                <ListItem button key="Store Deliveries Pending Approval" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Deliveries Pending Approval</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/view/invoices" className={classes.link}>
                                <ListItem button key="View Invoices & Credit Notes" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Invoices & Credit Notes</Typography>} />
                                </ListItem>
                              </Link>
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/indent" className={classes.link}>
                                  <ListItem button key="View Indent" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Indent</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inactive/stores/delivery" className={classes.link}>
                                  <ListItem button key="View Inactive Stores by Delivery Pattern" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Inactive Stores by Delivery Pattern</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/stores/no/orders" className={classes.link}>
                                  <ListItem button key="View Stores with no orders" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Stores with no orders</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/stores/no/recent/orders/lastfewdays" className={classes.link}>
                                  <ListItem button key="Stores with no recent order" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Stores with no recent order</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) &&
                                <Link to="/stores/outstanding/ledger" className={classes.link}>
                                  <ListItem button key="Stores Outstanding Ledger Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Stores Outstanding Ledger Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/stores/earnings" className={classes.link}>
                                  <ListItem button key="Store Earning Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Earning Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                            </List>
                          </Collapse>
                        </List>
                      }
                      <Divider />
                      {this.state.modules_enabled.promotions_module && this.state.user.roles.includes(ROLES.ADMIN) &&
                        <Link to="/promotion" className={classes.link} onClick={this.handleDrawerClose}>
                          <ListItem button key="Promotions">
                            <ListItemIcon className={classes.menuIcon}><Icon>payment</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Promotions</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      {this.state.modules_enabled.promotions_module && this.state.user.roles.includes(ROLES.ADMIN) &&
                        <Divider />
                      }
                      {this.state.user.roles.includes(ROLES.ADMIN) &&
                        <Link to="/agent" className={classes.link} onClick={this.handleDrawerClose}>
                          <ListItem button key="Employees">
                            <ListItemIcon className={classes.menuIcon}><Icon>person</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Employees</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      {this.state.user.roles.includes(ROLES.ADMIN) &&
                        <Divider />
                      }
                      {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                        <Link to="/route" className={classes.link} onClick={this.handleDrawerClose}>
                          <ListItem button key="Routes">
                            <ListItemIcon className={classes.menuIcon}><Icon>directions</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Routes</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      {this.state.user.roles.includes(ROLES.ADMIN) &&
                        <Divider />
                      }
                      {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                        <List className={classes.subMenuTitle}>
                          <ListItem button onClick={(e) => this.handleClick('reports')}>
                            <ListItemIcon className={classes.menuIcon}><Icon>assignment</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2" align="left" className="sub-menu">Reports</Typography>} />
                            {this.state.openDrawer['reports'] ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>
                          <Collapse in={this.state.openDrawer['reports']} timeout="auto" unmountOnExit className={classes.subMenuItem}>
                            <List component="div" disablePadding onClick={this.handleDrawerClose}>
                              <Link to="/report/schedules" className={classes.link}>
                                <ListItem button key="Schedules" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Schedules</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/report/delivery/statewise" className={classes.link}>
                                <ListItem button key="Statewise Delivery Report" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Statewise Delivery Report</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/report/summary" className={classes.link}>
                                <ListItem button key="Summary" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Summary</Typography>} />
                                </ListItem>
                              </Link>
                              {this.state.modules_enabled.b2c_module &&
                                <Link to="/report/pendingbottle" className={classes.link}>
                                  <ListItem button key="Pending Bottle" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Pending Bottle</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              <Link to="/report/salesstats" className={classes.link}>
                                <ListItem button key="Product Trends" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Product Trends</Typography>} />
                                </ListItem>
                              </Link>
                              {this.state.modules_enabled.b2c_module && this.state.user.roles.includes(ROLES.ADMIN) &&
                                <Link to="/report/customertransactions" className={classes.link}>
                                  <ListItem button key="Customer Transactions" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Customer Transactions</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              <Link to="/report/salesreport" className={classes.link}>
                                <ListItem button key="Sales Report" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Sales Report</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/report/agentreport" className={classes.link}>
                                <ListItem button key="Agent Delivery Report" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Agent Delivery Report</Typography>} />
                                </ListItem>
                              </Link>
                              <Link to="/report/agent/performance/report" className={classes.link}>
                                <ListItem button key="Agents Performance Report" className={classes.nested}>
                                  <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Agents Performance Report</Typography>} />
                                </ListItem>
                              </Link>
                              {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/report/storebest2worst" className={classes.link}>
                                  <ListItem button key="Stores Best to Worst" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Stores Best to Worst</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/report/storesreport" className={classes.link}>
                                  <ListItem button key="Store Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/report/store/returns" className={classes.link}>
                                  <ListItem button key="Store Returns Pattern" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Returns Pattern</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/report/store/unattended" className={classes.link}>
                                  <ListItem button key="Unattended Stores" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Unattended Stores</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/report/store/shelf" className={classes.link}>
                                  <ListItem button key="Store Shelf Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Store Shelf Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                            </List>
                          </Collapse>
                        </List>
                      }
                      <Divider />
                      {this.state.modules_enabled.inventory_management && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                        <List className={classes.subMenuTitle}>
                          <ListItem button onClick={(e) => this.handleClick('inventory')}>
                            <ListItemIcon className={classes.menuIcon}><Icon>assessment</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2" align="left" className="sub-menu">Inventory</Typography>} />
                            {this.state.openDrawer['inventory'] ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>
                          <Collapse in={this.state.openDrawer['inventory']} timeout="auto" unmountOnExit className={classes.subMenuItem}>
                            <List component="div" disablePadding onClick={this.handleDrawerClose}>
                              {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/inventory/master" className={classes.link}>
                                  <ListItem button key="Manage Inventory Masters" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Manage Inventory Masters</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/inventory/transactions" className={classes.link}>
                                  <ListItem button key="Transactions" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Transactions</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inventory/stock/summary" className={classes.link}>
                                  <ListItem button key="Stock Summary" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Stock Summary</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inventory/daily/report" className={classes.link}>
                                  <ListItem button key="Daily Inventory Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Daily Inventory Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inventory/stock/report" className={classes.link}>
                                  <ListItem button key="Opening Stock Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Opening Stock Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inventory/stock/mismatch/report" className={classes.link}>
                                  <ListItem button key="Physical Stock Mismatch Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Physical Stock Mismatch Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_INCHARGE) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.MANAGEMENT)) &&
                                <Link to="/inventory/export/report" className={classes.link}>
                                  <ListItem button key="Inventory Report" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Inventory Report</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                            </List>
                          </Collapse>
                        </List>
                      }
                      <Divider />
                      {(this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS)) &&
                        <List className={classes.subMenuTitle}>
                          <ListItem button onClick={(e) => this.handleClick('tools')}>
                            <ListItemIcon className={classes.menuIcon}><Icon>pan_tool</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2" align="left" className="sub-menu">Tools</Typography>} />
                            {this.state.openDrawer['tools'] ? <ExpandLess /> : <ExpandMore />}
                          </ListItem>
                          <Collapse in={this.state.openDrawer['tools']} timeout="auto" unmountOnExit className={classes.subMenuItem}>
                            <List component="div" disablePadding onClick={this.handleDrawerClose}>
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/tools/notification" className={classes.link}>
                                  <ListItem button key="Notification" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Notification</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN)) &&
                                <Link to="/tools/managereasons" className={classes.link}>
                                  <ListItem button key="Manage Reasons" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Manage Reasons</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) &&
                                <Link to="/tools/organisation" className={classes.link}>
                                  <ListItem button key="Organisation Information" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Organisation Information</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT) || this.state.user.roles.includes(ROLES.ACCOUNTS) || this.state.user.roles.includes(ROLES.ACCOUNTS_ADMIN)) &&
                                <Link to="/import" className={classes.link}>
                                  <ListItem button key="Import" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Import</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                this.state.modules_enabled.b2c_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.DELIVERY_MANAGEMENT)) &&
                                <Link to="/export" className={classes.link}>
                                  <ListItem button key="Export" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Export</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/activity/tracking" className={classes.link}>
                                  <ListItem button key="Activity Tracking" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>Activity Tracking</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                              {
                                this.state.modules_enabled.b2b_module && (this.state.user.roles.includes(ROLES.ADMIN) || this.state.user.roles.includes(ROLES.STORE_MANAGEMENT)) &&
                                <Link to="/tools/jobs" className={classes.link}>
                                  <ListItem button key="View Scheduled Jobs" className={classes.nested}>
                                    <ListItemText primary={<Typography variant="subtitle1" style={{ fontSize: '0.875rem' }}>View Scheduled Jobs</Typography>} />
                                  </ListItem>
                                </Link>
                              }
                            </List>
                          </Collapse>
                        </List>
                      }
                      {
                        <Link to="/help" className={classes.link} onClick={this.handleDrawerClose}>
                          <ListItem button key="Routes">
                            <ListItemIcon className={classes.menuIcon}><Icon>help</Icon></ListItemIcon>
                            <ListItemText primary={<Typography variant="subtitle2">Help</Typography>} />
                          </ListItem>
                        </Link>
                      }
                      {
                        <Divider />
                      }
                    </div>
                    <Divider />
                    <Container maxWidth="sm" style={{ position: "absolute", bottom: 0, paddingBottom: 10 }}>
                      <Typography variant="body1" style={{ textAlign: 'center' }}>
                        Version: {global.appVersion}
                        <React.Fragment>
                          <br />Powered by Sysbrew
                        </React.Fragment>
                      </Typography>
                    </Container>
                  </Drawer>
                }
              </div>
              <Routes childProps={childProps} />
              {/* <div className='sweet-loading'>
                <CircleLoader
                  className={override}
                  sizeUnit={"px"}
                  size={50}
                  color={'#123abc'}
                  loading={this.state.loading}
                />
              </div> */}
              <Snackbar
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={this.state.sb.open}
                autoHideDuration={this.state.sb.autohide}
                onClose={this.handleSBClose}>
                <MySnackbarContent
                  onClose={this.handleSBClose}
                  actionText={this.state.sb.actionText}
                  actionCallback={this.state.sb.actionCallback}
                  variant={this.state.sb.varient}
                  message={this.state.sb.message}
                />
              </Snackbar>
              <DialogMUI
                disableEnforceFocus
                open={this.state.openDialog}
                onClose={this.closeConfirmDialog}
                fullWidth={true}
                maxWidth='sm'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                {this.state.dialog_title ? <DialogTitle id="alert-dialog-title">{this.state.dialog_title}</DialogTitle> : ''}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {this.state.dialog_message}
                  </DialogContentText>
                  {
                    this.state.showfield &&
                    <div>
                      <FormControl variant="outlined" key="field" fullWidth>
                        <OutlinedInput
                          fullWidth
                          placeholder={this.state.fieldHint}
                          defaultValue={this.state.fieldValue}
                          id="outlined-adornment-field"
                          onChange={(e) => { e.target.value && e.target.value.length > 0 && this.setState({ dialog_field_text: e.target.value }) }}
                          aria-describedby="outlined-weight-helper-text"
                          inputProps={{
                            'aria-label': 'rate',
                          }}
                          labelWidth={0}
                          multiline
                          rowsMax={2}
                        />
                      </FormControl>
                    </div>
                  }
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.closeConfirmDialog} color="primary">
                    {this.state.confirmAction ? this.state.cancel_title : "Ok"}
                  </Button>
                  {
                    this.state.confirmAction &&
                    <Button onClick={(e) =>
                      this.state.showfield ?
                        this.state.confirmAction(this.state.dialog_field_text) :
                        this.state.confirmAction()} color="primary" autoFocus>
                      {this.state.accept_title}
                    </Button>
                  }
                </DialogActions>
              </DialogMUI>
              <DialogMUI
                open={this.state.openDialog3Option}
                onClose={this.closeConfirmDialog3Option}
                fullWidth={true}
                maxWidth='sm'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                {dialog3OptionData && dialog3OptionData.dialog_title ? <DialogTitle id="alert-dialog-title">{dialog3OptionData.dialog_title}</DialogTitle> : ''}
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    {dialog3OptionData && dialog3OptionData.dialog_message}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button color="secondary" onClick={this.closeConfirmDialog3Option} style={{ float: 'left' }}>
                    Cancel
                  </Button>
                  {
                    dialog3OptionData && dialog3OptionData.middleButtonText &&
                    <Button onClick={dialog3OptionData && dialog3OptionData.middleButtonAction} color="primary">
                      {dialog3OptionData && dialog3OptionData.middleButtonText}
                    </Button>
                  }
                  {
                    dialog3OptionData && dialog3OptionData.rightButtonText &&
                    <Button onClick={dialog3OptionData && dialog3OptionData.rightButtonAction} color="primary">
                      {dialog3OptionData && dialog3OptionData.rightButtonText}
                    </Button>
                  }
                </DialogActions>
              </DialogMUI>
              <ProgressDialog open={this.state.progressOpen} message={this.state.progressMessage} />
            </DashboardContextProvider>
          </DndProvider>
        </ThemeProvider>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(App));
